module.exports = __webpack_public_path__ + "static/media/no-connect.bb80ecc5.svg";